(function () {
  function parseVariants(root) {
    const script =
      root.querySelector('script[data-variants-json]') ||
      root.querySelector('script[type="application/json"]');
    if (!script) return [];
    try {
      const v = JSON.parse(script.textContent || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function getSelectedValue(root, position) {
    const input = root.querySelector(`input.product-form__input__radio[data-option-position="${position}"]:checked`);
    return input ? String(input.value) : null;
  }

  function setLegendSelectedText(root, position, value) {
    const fs = root.querySelector(`fieldset[data-option-position="${position}"]`);
    if (!fs) return;
    const span = fs.querySelector('.product-form__input__option-value');
    if (span) span.textContent = value || '';
  }

  function setOptionValueVisibility(root, position, value, enabled) {
    const input = root.querySelector(
      `input.product-form__input__radio[data-option-position="${position}"][value="${CSS.escape(value)}"]`
    );
    if (!input) return;

    const li = input.closest('li');
    const label = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);

    if (enabled) {
      input.disabled = false;
      if (li) li.style.display = '';
      if (label) label.style.display = '';
    } else {
      input.disabled = true;

      // si estaba seleccionado y lo deshabilitamos, lo desmarcamos (para evitar quedarse “pegado”)
      if (input.checked) input.checked = false;

      if (li) li.style.display = 'none';
      if (label) label.style.display = 'none';
    }
  }

  function findFirstEnabledValue(root, position) {
    const inputs = Array.from(
      root.querySelectorAll(`input.product-form__input__radio[data-option-position="${position}"]`)
    );
    const first = inputs.find(i => !i.disabled);
    return first ? String(first.value) : null;
  }

  function clickValue(root, position, value) {
    const input = root.querySelector(
      `input.product-form__input__radio[data-option-position="${position}"][value="${CSS.escape(value)}"]`
    );
    if (input && !input.disabled) input.click();
  }

  function computeAvailabilityMap(variants, pos, selected) {
    // selected = {1: 'ROJO', 2:'21.4', ...}
    // devuelve set de valores permitidos para la opción pos según lo ya seleccionado antes
    const allowed = new Set();

    variants.forEach(v => {
      if (!v || !v.available) return;

      // comparar opciones previas
      for (let p = 1; p < pos; p++) {
        const sel = selected[p];
        if (sel == null) continue;
        const vv = v[`option${p}`];
        if (String(vv) !== String(sel)) return;
      }

      const value = v[`option${pos}`];
      if (value != null) allowed.add(String(value));
    });

    return allowed;
  }

  function refresh(root) {
    const variants = parseVariants(root);
    if (!variants.length) return;

    const totalPositions = root.querySelectorAll('fieldset[data-option-position]').length;

    // 1) leer seleccion actual (por posición)
    const selected = {};
    for (let p = 1; p <= totalPositions; p++) {
      selected[p] = getSelectedValue(root, p);
      if (selected[p]) setLegendSelectedText(root, p, selected[p]);
    }

    // 2) para cada posición >=2: habilitar/ocultar según selección previa
    for (let pos = 2; pos <= totalPositions; pos++) {
      const allowed = computeAvailabilityMap(variants, pos, selected);

      const inputs = Array.from(
        root.querySelectorAll(`input.product-form__input__radio[data-option-position="${pos}"]`)
      );

      inputs.forEach(inp => {
        const val = String(inp.value);
        setOptionValueVisibility(root, pos, val, allowed.has(val));
      });

      // 3) si no hay seleccionado en esta opción, o quedó inválido, escoger el primero habilitado
      const current = getSelectedValue(root, pos);
      if (!current || !allowed.has(String(current))) {
        const firstOk = findFirstEnabledValue(root, pos);
        if (firstOk) {
          // seleccionarlo para que Shopify calcule el variant correcto
          clickValue(root, pos, firstOk);
        }
      }
    }

    // 4) actualizar legend final (por si cambió por auto-selección)
    for (let p = 1; p <= totalPositions; p++) {
      const v = getSelectedValue(root, p);
      if (v) setLegendSelectedText(root, p, v);
    }
  }

  function installOne(root) {
    if (root.__ctAvailInstalled) return;
    root.__ctAvailInstalled = true;

    const handler = () => {
      // pequeño delay para que el componente de Shopify actualice internamente primero
      setTimeout(() => refresh(root), 0);
      setTimeout(() => refresh(root), 60);
    };

    root.addEventListener('change', handler, true);
    root.addEventListener('click', handler, true);

    // inicial
    setTimeout(() => refresh(root), 0);
    setTimeout(() => refresh(root), 80);
    setTimeout(() => refresh(root), 250);
  }

  function boot() {
    const roots = document.querySelectorAll('[data-ct-variant-availability="true"]');
    roots.forEach(installOne);

    // por si Shopify re-renderiza secciones
    const obs = new MutationObserver(() => {
      document.querySelectorAll('[data-ct-variant-availability="true"]').forEach(installOne);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
